import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPrescriptionBottleMedical,
  faCamera,
  faUser,
  faHouseMedical,
  faVialCircleCheck 
} from "@fortawesome/free-solid-svg-icons";


import { TbHomeFilled } from "react-icons/tb";
import { GiMedicines } from "react-icons/gi";
import { GiMedicinePills } from "react-icons/gi";
import { TbTestPipe } from "react-icons/tb";
import Badge from "@mui/material/Badge";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Nav.css";
import { useSelector } from "react-redux";

const Nav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const cartitems = useSelector((state) => state.cart.items);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleProfileClick = () => {
    navigate("/user-dashboard");
  };

  return (
    <div className="nav-container">
      <nav className="nav">
       <NavItem
  icon={<FontAwesomeIcon icon={faHouseMedical} className="cute-icon" />}
  label="Home"
  path="/home"
  onClick={scrollToTop}
  currentPath={location.pathname}
/>
<NavItem
  icon={<FontAwesomeIcon icon={faPrescriptionBottleMedical} className="cute-icon" />}
  label="Medicine"
  path="/AllMedicine"
  onClick={scrollToTop}
  currentPath={location.pathname}
/>
 <NavItem
  icon={<FontAwesomeIcon icon={faCamera} className="cute-icon" />}
  label="Prescription"
  path="/prescription"
  onClick={scrollToTop}
  currentPath={location.pathname}
/>

<NavItem
  icon={<FontAwesomeIcon icon={faVialCircleCheck} className="cute-icon" />}
  label="Lab Test"
  path="/labtest"
  onClick={scrollToTop}
  currentPath={location.pathname}
/>

        
<NavItem
  icon={<FontAwesomeIcon icon={faUser} className="cute-icon" />}
  label={isLoggedIn ? "Profile" : "Login"}
  path={isLoggedIn ? "/user-dashboard" : "/login"}
  currentPath={location.pathname}
  onClick={scrollToTop}
/>


      </nav>
    </div>
  );
};

const NavItem = ({ icon, label, path, currentPath, onClick }) => {
  const isActive =
    path === "/home"
      ? currentPath === "/" || currentPath === "/home"
      : currentPath === path;

  return (
    <Link 
      to={path} 
      className={`nav-item ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      <div className="nav-icon">{icon}</div>
      <span className="nav-label">{label}</span>
    </Link>
  );
};

export default Nav;